import { render, staticRenderFns } from "./RequirementsComponent.vue?vue&type=template&id=cf19b166"
import script from "./RequirementsComponent.vue?vue&type=script&lang=js"
export * from "./RequirementsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports